import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { countries, devConfig } from 'config/config'; // Importing countries and devConfig from configuration

/**
 * Class representing the view for registered documents table.
 * @extends JetView
 */
export default class tableRegisteredDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 60, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip text
                                    template: function (obj) {
                                        // Template for the column
                                        return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close details'></span>"; // Icons for edit and details
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Route', // Column ID
                                    header: _('Ruta'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'EncryptionValue', // Column ID
                                    header: _('Encriptación'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('Id Externo'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Profile', // Column ID
                                    header: _('Perfil'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    options: [
                                        // Options for the column
                                        { id: 'A', value: _('Activo') }, // Active option
                                        { id: 'I', value: _('Inactivo') }, // Inactive option
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaisId', // Column ID
                                    header: _('Pais'), // Localized column header
                                    options: countries, // Options for the column
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('version:id', [item.Id]); // Trigger event with item ID
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Check screen size
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                                edit: function (euv, id) {
                                    // Handler for edit icon click
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                                },
                            },
                            ready: function () {
                                // Event handler for when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
            on: {
                // Global event handlers
                onItemDblClick: (id) => {
                    // Handler for double-click on an item
                    $$('EditDocument').show(); // Show edit document window
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetDocuments'; // API URL for fetching documents
        var filter = ''; // Filter string
        this.on(this.app, 'registeredDocument:filter', (filterData) => {
            // Event listener for filtering documents
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
        });
        var datePopup = []; // Array for date popup options
        var datePopup2 = []; // Array for second date popup options
        var popupAdd = ''; // Variable for add document popup
        var popup = webix.ui({
            // Create edit document popup
            view: 'window',
            id: 'EditDocument', // ID for the popup
            width: 400, // Width of the popup
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Editar Documento') }, // Label for the popup
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Click handler for close icon
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for the popup
            modal: true, // Modal popup
            body: {
                view: 'form', // Form inside the popup
                id: 'editForm', // ID for the form
                elements: [
                    {
                        view: 'text', // Text input for ID
                        label: 'ID',
                        name: 'Id',
                        readonly: true, // Read-only field
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'text', // Text input for Name
                        label: _('Nombre'),
                        name: 'Name',
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'text', // Text input for Route
                        label: _('Ruta'),
                        name: 'Route',
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'text', // Text input for Version
                        label: _('Versión'),
                        name: 'Version',
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'text', // Text input for EncryptionValue
                        label: _('Encriptación'),
                        name: 'EncryptionValue',
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'text', // Text input for ExternalId
                        label: _('Id Externo'),
                        name: 'ExternalId',
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'combo', // Combo box for Type
                        label: _('Tipo'),
                        name: 'Type',
                        readonly: true, // Read-only field
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'combo', // Combo box for Profile
                        label: _('Perfil'),
                        name: 'Profile',
                        readonly: true, // Read-only field
                        labelWidth: 120, // Label width
                    },
                    {
                        view: 'combo', // Combo box for IsActivate
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            // Options for the combo box
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Deactivated option
                        ],
                        labelWidth: 120, // Label width
                    },
                    {
                        cols: [
                            // Buttons for Cancel and Save
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    // Click handler for cancel button
                                    this.getTopParentView().hide(); // Hide the popup
                                    $$('editForm').setValues($$('editForm').getCleanValues()); // Reset form values
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    // Click handler for save button
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to update document
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RegisteredDocument/UpdateDocument',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Route":"' +
                                                values.Route +
                                                '", "Version":"' +
                                                values.Version +
                                                '", "Type":"' +
                                                values.Type +
                                                '", "Profile":"' +
                                                values.Profile +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","EncryptionMethod":"SHA-1", "EncryptionValue":"' +
                                                values.EncryptionValue +
                                                '", "ExternalId":"' +
                                                values.ExternalId +
                                                '"}', // JSON payload
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handler
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handler
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (resp.HasError) {
                                                        // Check for errors
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error', // Error type
                                                            text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                        });
                                                    } else {
                                                        webix.message('Documento Registrado'); // Success message
                                                        grid.clearAll(); // Clear the datatable
                                                    }
                                                },
                                            },
                                        );
                                    $$('editForm').setValues($$('editForm').getCleanValues()); // Reset form values
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editForm').bind($$('datatable')); // Bind form to datatable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for after sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'addDocument:button', (filter) => {
            // Event listener for adding documents
            webix
                .ajax() // AJAX request to get document types
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(devConfig.geturlApi() + 'RegisteredDocument/TypeDocument', '', {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handler
                        webix.message('Error! '); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handler
                        var resp = JSON.parse(text); // Parse response
                        if (!resp.HasError) {
                            // Check for errors
                            datePopup = resp.Data; // Store document types
                        }
                        webix
                            .ajax() // AJAX request to get profiles
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(devConfig.geturlApi() + 'Select/GetProfile', '', {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handler
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handler
                                    var resp = JSON.parse(text); // Parse response
                                    if (!resp.HasError) {
                                        // Check for errors
                                        datePopup2 = resp.Data; // Store profiles
                                    }
                                    popupAdd = webix.ui({
                                        // Create add document popup
                                        view: 'window',
                                        id: 'AddDocument', // ID for the popup
                                        width: 400, // Width of the popup
                                        head: {
                                            view: 'toolbar', // Toolbar for the popup header
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Añadir Documento'), // Label for the popup
                                                },
                                                {
                                                    view: 'icon', // Close icon
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        // Click handler for close icon
                                                        this.getTopParentView().hide(); // Hide the popup
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center position for the popup
                                        modal: true, // Modal popup
                                        body: {
                                            view: 'form', // Form inside the popup
                                            id: 'addform', // ID for the form
                                            elements: [
                                                {
                                                    id: 'r5', // ID for the row
                                                    rows: [
                                                        {
                                                            view: 'text', // Text input for Name
                                                            label: _('Nombre'),
                                                            name: 'Name',
                                                            id: 'Name',
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'text', // Text input for Route
                                                            label: _('Ruta'),
                                                            name: 'Route',
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'text', // Text input for Version
                                                            label: _('Versión'),
                                                            name: 'Version',
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'text', // Text input for EncryptionValue
                                                            label: _('Encriptación'),
                                                            name: 'EncryptionValue',
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for Type
                                                            label: _('Tipo'),
                                                            name: 'Type',
                                                            options: datePopup, // Options for the combo box
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for IsActivate
                                                            label: _('Estado'),
                                                            name: 'IsActivate',
                                                            options: [
                                                                // Options for the combo box
                                                                {
                                                                    id: 'A',
                                                                    value: _('Activado'), // Activated option
                                                                },
                                                                {
                                                                    id: 'I',
                                                                    value: _('Inactivado'), // Deactivated option
                                                                },
                                                            ],
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for Profile
                                                            label: _('Perfil'),
                                                            name: 'Profile',
                                                            options: datePopup2, // Options for the combo box
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for TypeMethod
                                                            label: _('Tipo Método'),
                                                            name: 'TypeMethod',
                                                            options: [
                                                                // Options for the combo box
                                                                {
                                                                    id: '0',
                                                                    value: _('Propio'), // Own option
                                                                },
                                                                {
                                                                    id: '1',
                                                                    value: _('Proveedor'), // Provider option
                                                                },
                                                            ],
                                                            on: {
                                                                // Event handler for change event
                                                                onChange: function (data, obj) {
                                                                    var currentValue = this.getValue(); // Get current value
                                                                    if (currentValue == '1') {
                                                                        // Check if provider is selected
                                                                        webix
                                                                            .ajax() // AJAX request to get document provider
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'RegisteredDocument/GetDocumentProvider',
                                                                                '',
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Error handler
                                                                                        webix.message(_('Error! ')); // Show error message
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        // Success handler
                                                                                        var response = JSON.parse(text); // Parse response
                                                                                        $$('r5').addView({
                                                                                            // Add view for external ID
                                                                                            id: 'r6',
                                                                                            rows: [
                                                                                                {
                                                                                                    cols: [
                                                                                                        {
                                                                                                            view: 'text', // Text input for ExternalId
                                                                                                            label: _(
                                                                                                                'Id Externo',
                                                                                                            ),
                                                                                                            name: 'ExternalId',
                                                                                                            labelWidth: 120, // Label width
                                                                                                            disabled: true, // Disabled field
                                                                                                            id: 'selectExternalId', // ID for the input
                                                                                                        },
                                                                                                        {
                                                                                                            width: 30, // Width for the button
                                                                                                            css: 'back-button', // CSS class for styling
                                                                                                            view: 'button', // Button for searching external ID
                                                                                                            type: 'icon',
                                                                                                            icon: 'icon-magnifying-glass',
                                                                                                            align: 'center',
                                                                                                            click: () => {
                                                                                                                // Click handler for search button
                                                                                                                webix
                                                                                                                    .ui(
                                                                                                                        {
                                                                                                                            view: 'window', // Create search window
                                                                                                                            head: {
                                                                                                                                view: 'toolbar', // Toolbar for the window header
                                                                                                                                cols: [
                                                                                                                                    {
                                                                                                                                        view: 'label',
                                                                                                                                        label: _(
                                                                                                                                            'Id Externo',
                                                                                                                                        ), // Label for the window
                                                                                                                                        align: 'center',
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                        view: 'icon', // Close icon
                                                                                                                                        icon: 'wxi-close',
                                                                                                                                        click: function () {
                                                                                                                                            // Click handler for close icon
                                                                                                                                            this.getTopParentView().hide(); // Hide the window
                                                                                                                                        },
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                            id: 'searchExternalId', // ID for the search window
                                                                                                                            modal: true, // Modal window
                                                                                                                            position:
                                                                                                                                'center', // Center position for the window
                                                                                                                            width: 500, // Width of the window
                                                                                                                            height: 425, // Height of the window
                                                                                                                            body: {
                                                                                                                                rows: [
                                                                                                                                    {
                                                                                                                                        view: 'datatable', // DataTable for displaying external IDs
                                                                                                                                        select: true, // Enable row selection
                                                                                                                                        columns:
                                                                                                                                            [
                                                                                                                                                {
                                                                                                                                                    id: 'id', // Column ID
                                                                                                                                                    header: [
                                                                                                                                                        'Id',
                                                                                                                                                        {
                                                                                                                                                            content:
                                                                                                                                                                'textFilter', // Text filter for the column
                                                                                                                                                        },
                                                                                                                                                    ],
                                                                                                                                                    width: 250, // Column width
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    id: 'value', // Column ID
                                                                                                                                                    header: [
                                                                                                                                                        _(
                                                                                                                                                            'Nombre',
                                                                                                                                                        ), // Localized column header
                                                                                                                                                        {
                                                                                                                                                            content:
                                                                                                                                                                'textFilter', // Text filter for the column
                                                                                                                                                        },
                                                                                                                                                    ],
                                                                                                                                                    fillspace: true, // Fill space for the column
                                                                                                                                                },
                                                                                                                                            ],
                                                                                                                                        data: response.Data, // Data for the datatable
                                                                                                                                        on: {
                                                                                                                                            onItemDblClick:
                                                                                                                                                function (
                                                                                                                                                    id,
                                                                                                                                                ) {
                                                                                                                                                    // Handler for double-click on item
                                                                                                                                                    var item =
                                                                                                                                                        this.getItem(
                                                                                                                                                            id,
                                                                                                                                                        ); // Get the clicked item
                                                                                                                                                    $$(
                                                                                                                                                        'selectExternalId',
                                                                                                                                                    ).setValue(
                                                                                                                                                        item.id,
                                                                                                                                                    ); // Set external ID value
                                                                                                                                                    $$(
                                                                                                                                                        'Name',
                                                                                                                                                    ).setValue(
                                                                                                                                                        item.value,
                                                                                                                                                    ); // Set name value
                                                                                                                                                    $$(
                                                                                                                                                        'Name',
                                                                                                                                                    ).define(
                                                                                                                                                        'disabled',
                                                                                                                                                        true,
                                                                                                                                                    ); // Disable name input
                                                                                                                                                    $$(
                                                                                                                                                        'searchExternalId',
                                                                                                                                                    ).hide(); // Hide search window
                                                                                                                                                },
                                                                                                                                        },
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                        },
                                                                                                                    )
                                                                                                                    .show(); // Show search window
                                                                                                            },
                                                                                                        },
                                                                                                    ],
                                                                                                },
                                                                                            ],
                                                                                        });
                                                                                    },
                                                                                },
                                                                            );
                                                                    } else {
                                                                        $$('r5').removeView('r6'); // Remove external ID view
                                                                        $$('Name').define('disabled', false); // Enable name input
                                                                    }
                                                                },
                                                            },
                                                            required: true, // Required field
                                                            labelWidth: 120, // Label width
                                                        },
                                                        {
                                                            view: 'combo', // Combo box for CountrySelect
                                                            name: 'CountrySelect',
                                                            id: 'CountrySelect',
                                                            localId: 'regions:combo', // Local ID for the combo
                                                            label: _('País'), // Localized label
                                                            labelWidth: 120, // Label width
                                                            required: true, // Required field
                                                            options: {
                                                                body: {
                                                                    template: function (obj) {
                                                                        // Template for displaying country options
                                                                        return (
                                                                            "<i class='flags " +
                                                                            obj.icon +
                                                                            "'></i>" +
                                                                            obj.value
                                                                        );
                                                                    },
                                                                    data: countries, // Data for the options
                                                                },
                                                            },
                                                            css: 'prm-filterByCountry', // CSS class for styling
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        // Buttons for Cancel and Save
                                                        {
                                                            view: 'button',
                                                            value: _('Cancelar'), // Cancel button
                                                            click: function () {
                                                                // Click handler for cancel button
                                                                this.getTopParentView().hide(); // Hide the popup
                                                                $$('addform').setValues($$('addform').getCleanValues()); // Reset form values
                                                            },
                                                        },
                                                        {
                                                            view: 'button',
                                                            type: 'form', // Button type
                                                            value: _('Guardar'), // Save button
                                                            click: function ($e) {
                                                                // Click handler for save button
                                                                let values = $$('addform').getValues(); // Get form values
                                                                if ($$('addform').validate()) {
                                                                    // Validate form
                                                                    webix
                                                                        .ajax() // AJAX request to add document
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'RegisteredDocument/AddDocument',
                                                                            '{"Name":"' +
                                                                                values.Name +
                                                                                '", "Route":"' +
                                                                                values.Route +
                                                                                '", "Version":"' +
                                                                                values.Version +
                                                                                '", "Type":"' +
                                                                                values.Type +
                                                                                '", "Profile":"' +
                                                                                values.Profile +
                                                                                '","IsActivate":"' +
                                                                                values.IsActivate +
                                                                                '","EncryptionMethod":"SHA-1", "EncryptionValue":"' +
                                                                                values.EncryptionValue +
                                                                                '", "TypeMethod":"' +
                                                                                values.TypeMethod +
                                                                                '", "ExternalId":"' +
                                                                                values.ExternalId +
                                                                                '", "CountryId":"' +
                                                                                values.CountrySelect +
                                                                                '"}', // JSON payload
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Error handler
                                                                                    webix.message('Error! '); // Show error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    // Success handler
                                                                                    var resp = JSON.parse(text); // Parse response
                                                                                    if (resp.HasError) {
                                                                                        // Check for errors
                                                                                        webix.message({
                                                                                            title: _('¡Error!'), // Error title
                                                                                            type: 'alert-error', // Error type
                                                                                            text: _(
                                                                                                'Ocurrio un error, comuniquese con soporte',
                                                                                            ), // Error message
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Documento Agregado',
                                                                                        ); // Success message
                                                                                        grid.clearAll(); // Clear the datatable
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('addform').setValues(
                                                                        $$('addform').getCleanValues(),
                                                                    ); // Reset form values
                                                                    this.getTopParentView().hide(); // Hide the popup
                                                                } else {
                                                                    webix.message({
                                                                        // Show validation error message
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error', // Error type
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        // Event handler for change event
                                                        this.validate(); // Validate form
                                                    },
                                                },
                                            },
                                        },
                                    });
                                    $$('addform').clearValidation(); // Clear validation for the form
                                    popupAdd.show(); // Show add document popup
                                },
                            });
                    },
                });
        });
        this.on(this.app, 'openEdit', (filterData) => {
            // Event listener for opening edit popup
            popup.show(); // Show edit document popup
        });
    }
}

// FILE DOCUMENTED
